import { useField } from 'formik';
import TableRow from '@mui/material/TableRow';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import React from 'react';
import styled from 'styled-components';
import TableCell from '@mui/material/TableCell';
import Typography from '@mui/material/Typography';
import { VspeedFormValues } from './VspeedFormValues';

const SpeedRow = (props: {
    name: keyof VspeedFormValues;
    label: string;
    standard: number;
    disabled?: boolean;
}) => {
    const [field, meta] = useField<number>(props.name);
    const tooltip = helpText[props.name];
    const value = field.value === undefined ? '' : field.value;
    return (
        <TableRow>
            <SpeedLabelCell>
                <Stack direction="row">
                    <Typography fontWeight={700}>{props.label}</Typography>
                    <Typography pl={0.5}> - {tooltip}</Typography>
                </Stack>
            </SpeedLabelCell>
            <StdCell>{props.disabled ? '--' : props.standard}</StdCell>
            {props.disabled ? (
                <StdCell>--</StdCell>
            ) : (
                <EditCell>
                    <TextField
                        variant="standard"
                        size="small"
                        placeholder={String(props.standard || '')}
                        name={field.name}
                        value={value}
                        onChange={field.onChange}
                        onBlur={field.onBlur}
                        error={Boolean(meta.touched && meta.error)}
                    />
                </EditCell>
            )}
        </TableRow>
    );
};

const SpeedLabelCell = styled(TableCell)`
    width: 100%;
    font-size: 14px;
    font-weight: 700;
`;

const StdCell = styled(TableCell)`
    font-size: 14px;
    text-align: end;
`;

const EditCell = styled(TableCell)`
    min-width: 160px;
    font-size: 14px;
    padding-right: 0;
    input {
        text-align: end;
    }
`;

const helpText: { [speed in keyof VspeedFormValues]: string } = {
    vr: 'Rotation speed',
    vx: 'Best angle-of-climb speed',
    vy: 'Best rate-of-climb speed',
    vref: 'Landing reference airspeed',
    vne: 'Never-exceed speed',
    vs0: 'Stalling speed',
    vs1: 'Stalling speed',
    vsw: 'Recommended touchdown speed',
    vmxt: 'Maximum taxi ground speed',
};

export default SpeedRow;
